var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2502",
    "data-name": "\\uADF8\\uB8F9 2502",
    transform: "translate(-72 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3662",
    "data-name": "\\uADF8\\uB8F9 3662",
    transform: "translate(72 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1695",
    "data-name": "\\uD328\\uC2A4 1695",
    d: "M5.113,343.924a2.553,2.553,0,0,1-2.556,2.549c-.706,0-2.556-.114-2.556-.114v-2.435a2.556,2.556,0,0,1,5.113,0",
    transform: "translate(0 -321.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1696",
    "data-name": "\\uD328\\uC2A4 1696",
    d: "M5.113,173.326a2.556,2.556,0,1,1-2.556-2.549,2.553,2.553,0,0,1,2.556,2.549",
    transform: "translate(0 -160.821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1697",
    "data-name": "\\uD328\\uC2A4 1697",
    d: "M5.113,2.548A2.556,2.556,0,1,1,2.556,0,2.553,2.553,0,0,1,5.113,2.548",
    transform: "translate(0 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1698",
    "data-name": "\\uD328\\uC2A4 1698",
    d: "M171.373,24.736H150.781a.3.3,0,0,1-.305-.3v-1.9a.3.3,0,0,1,.305-.3h20.592a.3.3,0,0,1,.305.3v1.9a.3.3,0,0,1-.305.3",
    transform: "translate(-141.678 -20.931)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1699",
    "data-name": "\\uD328\\uC2A4 1699",
    d: "M171.373,195.489H150.781a.3.3,0,0,1-.305-.3v-1.9a.3.3,0,0,1,.305-.3h20.592a.3.3,0,0,1,.305.3v1.9a.3.3,0,0,1-.305.3",
    transform: "translate(-141.678 -181.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1700",
    "data-name": "\\uD328\\uC2A4 1700",
    d: "M171.373,366.356H150.781a.3.3,0,0,1-.305-.3v-1.9a.3.3,0,0,1,.305-.3h20.592a.3.3,0,0,1,.305.3v1.9a.3.3,0,0,1-.305.3",
    transform: "translate(-141.678 -342.635)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-Filter.a57b54abe4921201e89831e3736f6b5e.svg";
export { ForwardRef as ReactComponent };